module.exports = __webpack_public_path__ + "src/class3/img/logo-2.7cf03d14.png";